exports.reduce = require('rxjs/internal/operators/reduce').reduce



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sanity/observable/operators/reduce.js
// module id = 142
// module chunks = 0